import {Header} from "./Header";
import {Footer} from "./Footer";
import styles from "../../styles/layout/layout.module.css"
import EventPage from "../Event";
export const Layout = ({children}) =>{
    return (
        <div className={styles.containerLayout}>

            <Header/>
            <main className={styles.bodyMainContainer}>
                {children}
            </main>
            {/*<EventPage/>*/}
            <Footer/>
        </div>
    )
}